// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-k0GK_wGX fl clearfix","list":"list-3CUsJjeK","qqg":"qqg-f8Emn3SY"};